module.exports = "/build/images/logo.d991566f.svg";